  if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
  if ((typeof Shopify.getCart) === 'undefined') {
    Shopify.getCart = function(callback, cart) {
      if(!cart){
      return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
          if ((typeof callback) === 'function') {
          callback(cart,textStatus, xhr);
        }
        else {
          Shopify.onCartUpdate(cart);
            }
        });
      }else{
        if ((typeof callback) === 'function') {
        callback(cart);
      }else if(typeof Shopify.onCartUpdate ==='function') {
        Shopify.onCartUpdate(cart);
          }
      }
    };
  }

window.stryx = window.stryx || {};

$(function () {
  stryx.startInCartUpsell();

  var itemsCount = 0;
  $("#side-cart form .quantity-box input[type=number]").each(function () {
    itemsCount += parseInt($(this).val());
  });
  $(".header .cart-wrap span.count").html(itemsCount);

  const postCart = () => {
    // console.log("🛍👉 postCart : ", $("#side-cart form").serialize());

    return $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: $("#side-cart form").serialize(),
      dataType: "json",
    })
      .fail(function (error) {
        // console.error("error:", error);
        $("#add-cart-overlay").fadeOut();
      })
      .done(function () {
        Shopify.getCart(function(cart) {
          addToCartSuccess();
          $("#add-cart-overlay").fadeOut();
        }.bind(this));  
      });
  };

  async function updateCart() {
    $("#loading-overlay").show();
    try {
      updatingCartRequest = await postCart();
    } catch (e) {
      $("#add-cart-overlay").fadeOut();
    }
  }

  const addToCart = (id) => {
    let data = { id, quantity: 1 };

    // console.log("🛍👉 ", data);

    return $.ajax({
      url: "/cart/add.js",
      dataType: "json",
      type: "post",
      data: data,
      success: function (itemData) {
        addToCartSuccess();
        sessionStorage.removeItem("interval_modal");
        $("#add-cart-overlay").fadeOut();
      },
      error: function (XMLHttpRequest) {
        var response = eval("(" + XMLHttpRequest.responseText + ")");
        response = response.description;
        // console.log(response);
        sessionStorage.removeItem("interval_modal");
        $("#add-cart-overlay").fadeOut();
      },
    });
  };

  $("form .plus, form .minus ").click(function () {
    setTimeout(function () {
      $("#side-cart input[type=number]").change();
    }, 1000);
  });

  $("#side-cart .pluss").click(function () {
    var plus = $(this).parent().find("input").val();
    $(this)
      .parent()
      .find("input")
      .val(parseInt(plus) + 1);
  });

  $("#side-cart .minuss").click(function () {
    var minus = $(this).parent().find("input").val();
    if (minus > 1) {
      $(this)
        .parent()
        .find("input")
        .val(parseInt(minus) - 1);
    }
  });

  $("#side-cart .btn-recomment").click(function () {
    // console.log("👉 btn-recomment", this);
    let variantID = this.getAttribute("data-variant");
    // console.log("VARIANT", variantID);
    if (variantID) {
      // console.log("👉 NO MODAL");
      $("#loading-overlay").show();
      addToCart(variantID);
      return;
    }
    const handleProduct = this.getAttribute("data-value");
    console.log("SKIO \n\n\n");
    showProductsModal(handleProduct);
    return;
  });

  let onChangeTimeout;
  let removeTimeout;
  $("#side-cart .remove").click(function () {
    $(this).closest(".item").find("input[type=number]").val(0);

    if (onChangeTimeout) clearTimeout(onChangeTimeout);
    onChangeTimeout = setTimeout(function () {
      updateCart();
    }, 500);

    if (removeTimeout) clearTimeout(removeTimeout);
    removeTimeout = setTimeout(function () {
      var count = $("#side-cart .head  .title span").text();
      $(".top-header .count").text(count);
    }, 550);
  });

  $("#side-cart form input[type=number]").change(function () {
    if (onChangeTimeout) clearTimeout(onChangeTimeout);

    // console.log(">change number");

    onChangeTimeout = setTimeout(function () {
      updateCart();
    }, 500);
  });

  $("#side-cart .input_product-subscription").click(function () {
    if ($(this).hasClass("subscription_active")) {
      $(this).removeClass("subscription_active");
      $(this).parent().find("ul").hide();
    } else {
      $(this).addClass("subscription_active");
      $(this).parent().find("ul").show();
    }
  });

  $("#side-cart .rc_radio__autodeliver").click(function () {
    var data_auto_renew = $(this).attr("data_auto_renew");
    var line_number = $(this).attr("line_number");
    var data_qty = $(this).attr("data_qty");
    var data_variant_id = $(this).attr("data_variant_id");
    var selling_plan = $(this).attr("data_selling_plan");

    if (data_auto_renew == "yes") {
      $("#loading-overlay").show();
      var e = { line: line_number, quantity: 0 };

      $.ajax({
        url: "/cart/change.js",
        dataType: "json",
        type: "post",
        data: e,
        success: function (itemData) {
          var data = {
            id: data_variant_id,
            quantity: data_qty,
          };

          $.ajax({
            url: "/cart/add.js",
            dataType: "json",
            type: "post",
            data: data,
            success: function (itemData) {
              addToCartSuccess();
              $("#add-cart-overlay").fadeOut();
            },
            error: function (XMLHttpRequest) {
              var response = eval("(" + XMLHttpRequest.responseText + ")");
              response = response.description;
              // console.log(response);
            },
          });
        },
        error: function (XMLHttpRequest) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
          // console.log(response);
        },
      });
    } else {
      $("#loading-overlay").show();
      var e = { line: line_number, quantity: 0 };

      // console.log("👉 ReCharge : NO : ", e);

      $.ajax({
        url: "/cart/change.js",
        dataType: "json",
        type: "post",
        data: e,
        success: function (itemData) {
          var data = {
            id: data_variant_id,
            quantity: data_qty,
            selling_plan: selling_plan,
          };

          // console.log("👉 ReCharge : NO : 2 : ", data);

          $.ajax({
            url: "/cart/add.js",
            dataType: "json",
            type: "post",
            data: data,
            success: function (itemData) {
              addToCartSuccess();
              $("#add-cart-overlay").fadeOut();
            },
            error: function (XMLHttpRequest) {
              var response = eval("(" + XMLHttpRequest.responseText + ")");
              response = response.description;
              // console.log(response);
            },
          });
        },
        error: function (XMLHttpRequest) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
          // console.log(response);
        },
      });
    }
  });
});

function updateItem(variant_id, qty, line, selling_plan) {
  var data = {
    line: line,
    quantity: 0,
  };
  $("#loading-overlay").show();

  $.ajax({
    url: "/cart/change.js",
    dataType: "json",
    type: "post",
    data: data,
    success: function (itemData) {
      var data = {
        id: variant_id,
        quantity: qty,
        selling_plan: selling_plan,
      };

      // console.log("👉 ReCharge : NO : 2 : ", data);

      $.ajax({
        url: "/cart/add.js",
        dataType: "json",
        type: "post",
        data: data,
        success: function (itemData) {
          addToCartSuccess();
          $("#add-cart-overlay").fadeOut();
        },
        error: function (XMLHttpRequest) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
          // console.log(response);
        },
      });
    },
    error: function (XMLHttpRequest) {
      var response = eval("(" + XMLHttpRequest.responseText + ")");
      response = response.description;
      // console.log(response);
    },
  });
}

async function checkDiscount() {
  function get_cookie(name) {
    return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2];
  }
  do {
    token = get_cookie("cart");
  } while (token == undefined);
  var discount = "HZB5X17F4CXT";
  let discountValue = discount_code_cart.value;
  // console.log("DISCOUNT", discountValue);
  // $.get("https://checkout.rechargeapps.com/shippingamount_responsive?store_id=85397&cart_token=" + token + "&discount_code=" + discount, function (data, status) {
  //     console.log("RESPONSE", data.discount_error)
  // });
  let url = "/discount_codes/lookup.json?code=HZB5X17F4CXT";
  let response = await fetch(
    "https://checkout.rechargeapps.com/shippingamount_responsive?store_id=85397&cart_token=" +
      token +
      "&discount_code=" +
      discount
  ).then((x) => x.json());
  // console.log("REsponse fetch", response);
}

function selectColor(e) {
  document
    .querySelectorAll("#modal_cart_content .option_color")
    .forEach((x) => x.classList.remove("active"));
  e.classList.add("active");
  let value = e.getAttribute("data_value");

  sessionStorage.setItem("option_color_modal", value);
  sessionStorage.setItem("variantIdModal", value);
}

window.stryx.cartModalSelectColor = function (index, el) {
  selectColor(el);
};

function selectFrequency(event) {
  const { value, name } = event.target;

  var currentVariantID = sessionStorage.getItem("variantIdModal");

  if (value !== "onetime") {
    // document
    //   .querySelector("#reder_product_cart .product-subscription__interval-list")
    //   .classList.add("show");

    if (
      window.stryx &&
      window.stryx.modalAddCartData &&
      window.stryx.modalAddCartData.product &&
      window.stryx.modalAddCartData.product.ReCharge &&
      window.stryx.modalAddCartData.product.ReCharge.oneTime &&
      window.stryx.modalAddCartData.product.ReCharge.oneTime[currentVariantID]
    ) {
      sessionStorage.setItem(
        "variantIdModal",
        window.stryx.modalAddCartData.product.ReCharge.oneTime[currentVariantID]
      );
    }

    sessionStorage.setItem(
      "interval_modal",
      $(".product-subscription__interval-input").attr("data-value") || 3
    );
  } else {
    if (
      window.stryx &&
      window.stryx.modalAddCartData &&
      window.stryx.modalAddCartData.product &&
      window.stryx.modalAddCartData.product.ReCharge &&
      window.stryx.modalAddCartData.product.ReCharge.subscriptions &&
      window.stryx.modalAddCartData.product.ReCharge.subscriptions[
        currentVariantID
      ]
    ) {
      sessionStorage.setItem(
        "variantIdModal",
        window.stryx.modalAddCartData.product.ReCharge.subscriptions[
          currentVariantID
        ]
      );
    }

    sessionStorage.removeItem("interval_modal");
    document
      .querySelector("#reder_product_cart .product-subscription__interval-list")
      .classList.remove("show");
  }
}

function selectFrequencyOption(e) {
  let selling_plan = e.getAttribute("data-selling-plan");
  let value = e.getAttribute("data-dropdown-value");
  let text = e.textContent;
  $(".product-subscription__interval-input").attr("data-value", value);
  sessionStorage.setItem("interval_modal", value);
  let selectedOption = document.querySelector(
    "#reder_product_cart .text_deliver"
  );
  selectedOption.innerHTML = text;
  if (selling_plan) {
    selectedOption.setAttribute("data-selling-plan", selling_plan);
  }
  e.parentNode.classList.toggle("show");
}

function toggleList(e) {
  e.parentNode
    .querySelector(".product-subscription__interval-list")
    .classList.toggle("show");
}
function addToCartFromModal() {
  $("#loading-overlay").show();

  let id = sessionStorage.getItem("variantIdModal");

  let selectedOption = document.querySelector(
    "#reder_product_cart .text_deliver"
  );
  let selected_selling_plan_option_name =
    selectedOption && selectedOption.textContent.trim();

  let selling_plan;
  let variant_id_with_gid;
  document.querySelectorAll("#modal_add_cart li").forEach(function (li) {
    variant_id_with_gid = li.getAttribute("data-variant-id");
    var variant_id_without_gid =
      variant_id_with_gid.split("/ProductVariant/")[1];
    if (
      variant_id_without_gid === id &&
      li.textContent.trim() === selected_selling_plan_option_name
    ) {
      selling_plan = li.getAttribute("data-selling-plan");
    }
  });

  let data = { id, quantity: 1 };

  if (selling_plan) {
    data.selling_plan = selling_plan;
  }

  $.ajax({
    url: "/cart/add.js",
    dataType: "json",
    type: "post",
    data: data,
    success: function (itemData) {
      closeModalAddToCart();
      addToCartSuccess();
      $("#add-cart-overlay").fadeOut();
    },
    error: function (XMLHttpRequest) {
      var response = eval("(" + XMLHttpRequest.responseText + ")");
      response = response.description;
    },
  });
}

setTimeout(() => {
  var buyNow = document.getElementById("checkoutBtn");
  // console.log("Buy now", buyNow);
  buyNow &&
    buyNow.addEventListener("click", function (evt) {
      evt.preventDefault();

      // Use the ajax API to add the product to the cart here. Once that request succeeds, then do this:

      $("#checkoutBtn .btn").addClass("stryx-btn-loading");

      window.location.href = `${window.location.origin}/checkout`;

      setTimeout(function () {
        $("#checkoutBtn .btn").removeClass("stryx-btn-loading");
      }, 5000);
    });
  // console.log(document.querySelectorAll(".option_color > img"));

  document
    .querySelectorAll("#side-cart .option_color > img")
    .forEach((element, indx, options) => {
      options.forEach((option) => option.parentNode.classList.remove("active"));
      element.parentNode.classList.add("active");
      element.addEventListener("click", () => {
        let id = element.parentNode.getAttribute("data_value");
        let values = document.querySelectorAll(".select-variant > li");
        values.forEach((value) => {
          let idList = value.getAttribute("data_value");
          if (id === idList) {
            value.click();
          }
        });
      });
    });
}, 500);

function changeCount(state, element) {
  let count = element.parentNode.querySelector("p");

  var $el = $(element);
  var $item = $el.parents(".item");
  var $formFieldForQuantity = $item.find(".wrap_input_qty input");
  var $formMore = $item.find(".wrap_input_qty .plus");
  var $formMinus = $item.find(".wrap_input_qty .minus");
  var newTotal;

  if (state) {
    newTotal = Number(count.textContent) + 1;
    count.innerHTML = newTotal;

    // $formFieldForQuantity.val(newTotal);

    // document.querySelector("#side-cart .wrap_input_qty .plus").click();
    $formMore.click();
  } else {
    newTotal = Number(count.textContent == 0)
      ? count.textContent
      : count.textContent - 1;
    count.innerHTML = newTotal;

    // $formFieldForQuantity.val(newTotal);

    // document.querySelector("#side-cart .wrap_input_qty .minus").click();
    $formMinus.click();
  }

  $formFieldForQuantity.val(newTotal);

  // document.querySelector("#side-cart .wrap_input_qty input").value = count.textContent;
}
